module.exports = __webpack_public_path__ + "static/googleserp-37f7bd0e653a36cf24acf2216c06a018.png";